import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { DescriptionImageApiModel } from '@app/api/api-models/text-image-editor/DescriptionImageApiModel';
import { SelectedResourceImageApiModel } from '@app/api/api-models';
import { BlobFileApiModel } from '@app/api/api-models/BlobFileApiModel';
import { UploadFileService } from '@app/shared/services/upload-file.service';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class TextImageEditorService {
  public apiUrl = 'description-images';

  constructor(private readonly http: HttpClientService, private uploadFileService: UploadFileService) {}

  public getSelectedResourceImages(ids: Array<string>): Observable<SelectedResourceImageApiModel[]> {
    return this.http.post<SelectedResourceImageApiModel[]>(`${this.apiUrl}/get-resource-images-sas`, ids);
  }

  public uploadImage(file: File): Observable<DescriptionImageApiModel> {
    const payload = new FormData();
    this.uploadFileService.append(payload, file);

    return this.http.post<DescriptionImageApiModel>(`${this.apiUrl}/upload`, payload);
  }

  public download(id: string): Observable<BlobFileApiModel> {
    return this.http
      .get<BlobFileApiModel>(`${this.apiUrl}/download/${id}`)
      .pipe(map((x) => new BlobFileApiModel().deserialize(x)));
  }
}
